/* outside */
const ENABLE_SIMULATION = 'simulation/ENABLE_SIMULATION'
const DISABLE_SIMULATION = 'simulation/DISABLE_SIMULATION'
const SET_SIMULATION_DATA = 'simulation/SET_SIMULATION_DATA'
const SET_SIMULATION_RESULT = 'simulation/SET_SIMULATION_RESULT'
const CHANGE_SIMULATION_DATA = 'simulation/CHANGE_SIMULATION_DATA'
const CHANGE_SIMULATION_HOLIDAY = 'simulation/CHANGE_SIMULATION_HOLIDAY'

export default {
  ENABLE_SIMULATION,
  DISABLE_SIMULATION,
  SET_SIMULATION_DATA,
  SET_SIMULATION_RESULT,
  CHANGE_SIMULATION_DATA,
  CHANGE_SIMULATION_HOLIDAY
}


// WEBPACK FOOTER //
// ./src/actions/simulationTypes.js